export enum RouterOutletOption {
  OVERLAY = 'o',
  MODAL = 'modal',
  SEARCH = 'search',
}
